import { render, staticRenderFns } from "./DictEntryTableGroup.vue?vue&type=template&id=2f4c0555&"
import script from "./DictEntryTableGroup.vue?vue&type=script&lang=js&"
export * from "./DictEntryTableGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports